import React from "react";

import { Table } from "antd";

const LdasDetailLotTable = ({
  lots = [],
  lotCount,
  columns,
  onLotAdd,
  pagination,
}) => {
  return (
    <div className="ldas-detail-lot-section">
      <div className="ldas-detail-lot-section__head">
        <div className="ldas-detail-lot-section__title-wrap">
          <span className="ldas-detail-lot-section__title">Lot 관리</span>
          <span className="ldas-count-badge ldas-count-badge--active">
            {lotCount}
          </span>
        </div>
        {onLotAdd ? (
          <button
            type="button"
            className="ldas-detail-lot-add-btn"
            onClick={onLotAdd}
          >
            + Lot 추가
          </button>
        ) : null}
      </div>

      <div className="ldas-detail-lot-section__table">
        <div className="ldas-table-card ldas-table-card--borderless ldas-detail-lot-table">
          <Table
            tableLayout="fixed"
            columns={columns}
            dataSource={lots}
            rowKey="id"
            pagination={pagination ?? false}
            size="middle"
            components={{
              header: {
                cell: ({ children, className, style, ...rest }) => (
                  <th
                    {...rest}
                    className={["ldas-table-header-cell", className]
                      .filter(Boolean)
                      .join(" ")}
                    style={style}
                  >
                    {children}
                  </th>
                ),
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default LdasDetailLotTable;
